function filterDays(item) {
  switch (item) {
    case '月':
      return 1;
    case '火':
      return 2;
    case '水':
      return 3;
    case '木':
      return 4;
    case '金':
      return 5;
    case '土':
      return 6;
    case '日':
      return 0;
    default:
      return;
  }
}


function dateToString(date) {
  return date.getFullYear() + '-' + (date.getMonth()+1).toString().padStart(2, "0") + '-' + date.getDate().toString().padStart(2, "0");
}

/**
 * 指定可能な配送日時のfromとtoを返す
 */
function getShippingDateTerm() {
  
  let start_day = Number("3"); 
  let end_day = Number("30");     
  let disable_from = new Date("");      
  let disable_to = new Date("");          
  let disable_dates = "";                            
  let disable_days = "";                              
  let business_dates = "";                          

  
  let businessDates = business_dates.split(',');

  
  let disabledDaysTmp = disable_days.split(',');
  let disabledDays = disabledDaysTmp.map(function (element) {
    return filterDays(element);
  });

  
  let allDisableDates = [];
  for (let d = disable_from; d <= disable_to; d.setDate(d.getDate() + 1)) {
    allDisableDates.push(dateToString(d));
  }

  
  let disabledDates = disable_dates.split(',');
  disabledDates.map((date) => {
    const d = new Date(date);
    allDisableDates.push(dateToString(d));
  })
  allDisableDates = allDisableDates.concat(disabledDates);

  
  let today_date = new Date(Date.now() + ((new Date().getTimezoneOffset() + (9 * 60)) * 60 * 1000));

  
  let additional_day_count = today_date.getHours() >= "24" ? 1 : 0;

  
  let first_check_date = new Date(today_date.setDate(today_date.getDate() + additional_day_count));

  
  let count = 0;
  while (
    
    allDisableDates.includes(dateToString(first_check_date))
    
    || disabledDays.includes(first_check_date.getDay())
  ) {
    
    if (businessDates.includes(dateToString(first_check_date))) {
      break;
    }
    
    first_check_date.setDate(first_check_date.getDate() + 1);
    count++;
  }

  
  let from_date = new Date(today_date.setDate(today_date.getDate() + start_day + count - 1));
  
  let to_date = new Date(today_date.setDate(today_date.getDate() + end_day - start_day + 1));

  return [from_date, to_date]
}

/**
 * 指定可能な配送日時が選択されているかチェックする
 */
function checkShippingDate() {
  
  const selectedDate = document.getElementById("attributes-shipping-date").value;

  
  if (!selectedDate) {
    document.getElementById("attributes-shipping-date").value = '指定なし';
    return;
  }

  
  let shippingDateTerm = getShippingDateTerm();
  let from_date = shippingDateTerm[0];
  let to_date = shippingDateTerm[1];

  
  const targetDateRange = [];
  for (let d = from_date; d <= to_date; d.setDate(d.getDate() + 1)) {
    const formattedDate = d.getFullYear() + "/" + ("0" + (d.getMonth() + 1)).slice(-2) + "/" + ("0" + d.getDate()).slice(-2);
    targetDateRange.push(formattedDate);
  }

  
  if (!targetDateRange.includes(selectedDate)) {
    event.preventDefault();
    alert("指定できないお届け日が選択されています。再度ご指定ください。")
    window.location.href = '/cart';
  }
}

  
  let shippingDateTerm = getShippingDateTerm();
  let from_date = shippingDateTerm[0];
  let to_date = shippingDateTerm[1];

  
  let unavailable_days = "2026-11-05";
  unavailable_days = unavailable_days.split(',')
  let allEnableDays = [];
  for (let d = from_date; d <= to_date; d.setDate(d.getDate()+1) ) {
    if(!unavailable_days.includes(dateToString(d))) {
      allEnableDays.push(dateToString(d));
    }
  }
  

  
  // const promise = (fn, time = 3000) => {
  const promise = (fn, time = 100) => {
      return new Promise(resolve => {
          setTimeout(() => resolve(fn), time)
      })
  }

  
  window.addEventListener("DOMContentLoaded", function() {
    flatpickr('.data', {
      enable: allEnableDays,
      dateFormat: 'Y/m/d',
      locale: "ja",
    });
  });
  // promise((() => {
  //   const flatpickrCSS = document.createElement('link');
  //   flatpickrCSS.rel = 'stylesheet', flatpickrCSS.href = 'https://cdn.jsdelivr.net/npm/flatpickr/dist/flatpickr.min.css';
  //   document.head.appendChild(flatpickrCSS);
  // })())
  //   .then(() => {
  //     flatpickr('.data', {
  //       enable: allEnableDays,
  //       dateFormat: 'Y/m/d',
  //       locale: "ja",
  //     });
  //   }).then(()=>{
  //     console.log('flatpicker set');
  //   });


window.addEventListener("DOMContentLoaded", function() {
  const cartCheckoutWrapper = document.querySelector('.cart__checkout-wrapper');
  const cartCheckoutBtn = cartCheckoutWrapper.querySelector('.cart__checkout');
  cartCheckoutBtn.addEventListener('click', ()=>{
    checkShippingDate();
  });
})